import React, { FC, memo } from 'react'
import 'react-tooltip/dist/react-tooltip.css'
import { SpinnerWrapper, Bar } from './styled'

export const SpinnerComponent: FC = memo(() => (
	<SpinnerWrapper>
		{Array.from({ length: 8 }).map((_, index) => (
			// eslint-disable-next-line react/no-array-index-key
			<Bar key={index} index={index} />
		))}
	</SpinnerWrapper>
))
